export default __webpack_public_path__ + "static/media/slide4.ff692494.png";